import Box from '@mui/material/Box';
import P from '../Reusables/Typography/P'
import BulletSpan from './BulletSpan';
import LargerHeading from './LargerHeading';

const StandBuilders = () => {
    return (
        <Box 
            className="m-2 mt-6 ml-4 mr-4 f-size_2" 
            color={'grey'}
            sx={{
                fontSize: 12,
                '& .MuiTypography-root': {
                    width: '100%'
                }
            }}
        >
            <P>
                We work with stand builders across the country. If you're a stand builder and don't yet hire
                from Exhibit Hire, then why not give us an opportunity to show you what we can do?
                Why stand builders should work with us?

            </P>
            <BulletSpan number={1} text="Discounted pricing" />

            <P>
                We offer all stand builders discounted pricing. Simply register an account on our website
                and within 24 hours our team will apply your discount level to your account so you can see
                your personalised pricing when browsing our website.
            </P>
            <BulletSpan number={2} text="3D product renders" />

            <P>
                Once you've registered your account you'll be able to download DWG files for our products,
                enabling you to visualise them in your designs.
            </P>
            <BulletSpan number={3} text="Nationwide coverage" />

            <P>
                We supply to all the major exhibition centres in the country, and deliver to every show at
                London Olympia, ExCeL London, &amp; NEC Birmingham.
            </P>
            <BulletSpan number={4} text="Exhibition specialists" />

            <P>
                As our name suggests, we specialise in exhibitions! We understand how exhibitions work
                and have extensive experience working at venues. Our logistics team has one priority:
                getting your furniture delivered and collected at the right time, with the right team, and with
                the right equipment.
            </P>
            <BulletSpan number={5} text="Easy online booking" />

            <P>
                On our website you can order your furniture in just a few clicks. Simply choose the furniture
                you want, select the show and provide the stand details, and it's done!
                Once logged into our website you can also view all of your invoices as well as upcoming
                deliveries and collections.
            </P><br/>

            <P>
                If booking online is not your thing, or if you need to discuss your requirements with someone,
                then our account managers are just a phone call away on <a href={`tel:02033840369`} className="link">0203 384 0369</a>.
            </P><br/>
            <LargerHeading>
                Want to visit us?
            </LargerHeading>

            <P>
                We have a 5,000 sq ft showroom at our head office in South East London (by the Dartford
                Crossing). If you'd like to visit our showroom or have a warehouse tour then please contact us -
                we'd love to show you around!
            </P><br/>
            <LargerHeading>
                Want to work with us:
            </LargerHeading>

            <P>
                There are several ways to start working with us!
            </P>

            <ul>
                <li>
                    Register as a stand builder on our website.
                </li>
                <li>
                    Call one of our account managers on <a href={`tel:02033840369`} className="link">0203 384 0369</a>
                </li>
                <li>
                    Email us:  <a href={`mailto:sales@exhibithire.co.uk`} className="link">sales@exhibithire.co.uk</a>
                </li>
                {/* <li>
                    Whatsapp us:  <a href={`tel:07XXXXXXXXX`} className="link">07XXXXXXXXX</a>
                </li> */}
            </ul>
            <br/>

            <LargerHeading>
                Want to know more?
            </LargerHeading>
            <P>
                To find out more about our company and our history visit our about us page.
            </P>

        </Box>
    )
}

export default StandBuilders